<template>
  <div class="ticket-period">
    <!-- 利用開始日-->
    <div class="item">
      <div class="centered-qr-label">
        {{ $t("common.startDateLabel") }}（Start date of use）
      </div>
      <div class="date-section">
        <span class="date start-date-of-use">
          {{ displayDate(start) }}
        </span>
      </div>
    </div>

    <div class="centered-qr-divider">〜</div>

    <!-- 利用終了日-->
    <div class="item">
      <div class="centered-qr-label">
        {{ $t("common.endDateLabel") }}（End date of use）
      </div>
      <div class="date-section">
        <div class="date">
          <span class="year">{{ displayDate(limit).split(".")[0] }}.</span>
          <span class="due"
            >{{ displayDate(limit).split(".")[1] }}.{{
              displayDate(limit).split(".")[2]
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BFaceCenteredQRAvailablePeriodDisp",
  props: {
    start: {
      type: String,
      required: true,
    },
    limit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-period {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.date-section {
  display: flex;
  height: 12.27vw;
  align-items: center;
}

.date {
  font-weight: 700;
  font-size: 6.4vw;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.date.start-date-of-use {
  padding-top: 3.2vw;
}

.due {
  font-weight: 700;
  font-size: 8.53vw;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.year {
  font-weight: 700;
  font-size: 4.27vw;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.centered-qr-divider {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-weight: 700;
  font-size: 4.27vw;
  margin-bottom: 2.4vw;
  flex: 0 0 auto;
  padding: 0 1.33vw;
}
</style>
